export default __webpack_public_path__ + "38011c2ec5f5ce6d0f3de1fb0b79ad3d.jpg";